<!-- 登录后  图片分类  图片轮播页面 -->
<template>
  <el-container>
    <el-header height="90px">
      <pubhead></pubhead>
    </el-header>
    <el-main id="hellMain">
      <div id="main_div" style="overflow:hidden;">
        <el-scrollbar id="typeImgPan">
          <div class="comp">
            <ImgCarousel></ImgCarousel>
          </div>
          <div class="comp" style="margin-top:20px;margin-bottom: 20px;">
            <TypeCanvas typeName="新分类概览图"></TypeCanvas>
          </div>
        </el-scrollbar>
      </div>
    </el-main>
    <el-footer height="30px">
      <pubfooter></pubfooter>
    </el-footer>
  </el-container>
</template>

<script>
import pubhead from '@/components/public/head_searchbox'
import pubfooter from '@/components/public/footer'
import ImgCarousel from '@/components/imageTypesPage/carousel/carousel'
import TypeCanvas from '@/components/imageTypesPage/typeList/typeList'
export default {
  components: {
    pubhead: pubhead,
    pubfooter: pubfooter,
    ImgCarousel: ImgCarousel,
    TypeCanvas: TypeCanvas
  },
  data () {
    return {
      showFavList: false // 是否显示收藏列表标识
    }
  },
  methods: {
    showList () {
      // 普通图像列表检索时触发此函数用来保证检索列表组件是显示状态
      this.showFavList = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.comp {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

#lunbo {
  width: 100%;
}

.el-header {
  color: #333;
  text-align: center;
  padding-top: 10px;
}
.el-footer {
  color: #333;
  text-align: center;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #f10707;
  text-align: center;

  padding: 20px 0 20px 0;
}

#hellMain {
  overflow: hidden;
  height: calc(100vh - 120px);
}

#hellMain :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}

#main_div {
  height: calc(100vh - 120px);
}

#typeImgPan {
  height: calc(100vh - 120px);
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
